module.exports = __webpack_public_path__ + "static/media/hero2.a9dc45ac.png";